import React from "react";
import CurrecyFormmater from "react-currency-formatter";
import { Divider } from "antd";

export default props => (
  <div className={`col-lg-4 col-sm-12 text-center ${props.shadow ? "shadow p-0 mb-1 bg-white rounded" : ""}`}>
    <div className="ibox">
      <div className="ibox-content no-margins pb-1">
        <h2 className="text-capitalize text-success">{props.label}</h2>
      </div>
      <div className="ibox-content">
        <h1 className="no-margins">
          {props.isNotCurrency ? props.total : <CurrecyFormmater quantity={props.total} currency="BRL" />}
        </h1>
        {props.children ? <div>{props.children}</div> : <div></div>}
      </div>
      {props.footerLabel ?
        <div>
          <a
            href="#" 
            onClick={ props.onFooter }
          >
            <h3>{props.footerLabel}</h3>
          </a>
        </div> : <div />}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/theme/card/index.jsx